import { Component, Inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTabsModule } from '@angular/material/tabs';
import { FormsModule } from '@angular/forms';
import { KnowledgePage } from '../../../../../service/admin.service';
import { marked } from 'marked';

export interface KnowledgeDialogData {
  isEdit: boolean;
  page?: KnowledgePage;
  existingNames: string[];
}

@Component({
  selector: 'app-knowledge-dialog',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatSlideToggleModule,
    MatTabsModule,
    FormsModule
  ],
  templateUrl: './knowledge-dialog.component.html',
  styleUrl: './knowledge-dialog.component.less'
})
export class KnowledgeDialogComponent implements OnInit {
  isEdit = false;
  pageId?: number;

  name = '';
  description = '';
  content = '';
  published = true;

  existingNames: string[] = [];
  originalName = '';

  constructor(
    public dialogRef: MatDialogRef<KnowledgeDialogComponent>,
    private sanitizer: DomSanitizer,
    @Inject(MAT_DIALOG_DATA) public data: KnowledgeDialogData
  ) {}

  ngOnInit() {
    this.isEdit = this.data.isEdit;
    this.existingNames = this.data.existingNames || [];

    if (this.isEdit && this.data.page) {
      this.pageId = this.data.page.id;
      this.name = this.data.page.name;
      this.originalName = this.data.page.name;
      this.description = this.data.page.description;
      this.content = this.data.page.content;
      this.published = this.data.page.published;
    }
  }

  get renderedContent(): SafeHtml {
    const html = marked.parse(this.content || '*Nothing to preview yet*', { async: false }) as string;
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }

  get isNameTaken(): boolean {
    return this.existingNames.includes(this.name.trim());
  }

  get isNameValid(): boolean {
    return /^[a-z0-9_-]+$/.test(this.name.trim());
  }

  get isRenamed(): boolean {
    return this.isEdit && this.name.trim() !== this.originalName;
  }

  get canSave(): boolean {
    return !!this.name.trim() && this.isNameValid && !this.isNameTaken && !!this.description.trim();
  }

  onSave() {
    if (!this.canSave) {
      return;
    }

    const result: KnowledgePage = {
      id: this.pageId || 0,
      name: this.name.trim(),
      description: this.description.trim(),
      content: this.content,
      published: this.published,
      updated_at: ''
    };

    this.dialogRef.close(result);
  }

  onCancel() {
    this.dialogRef.close();
  }
}
